/* External dependencies */
import { gql } from "@apollo/client";

/* Local dependencies */
import { setAuthenticatedClient, anonymousClient, authenticatedClient } from "../../../../client/graphql";
import { User } from "../../../users/types";

export const getUser = async (id: string): Promise<User> => {

  try {
    console.log('Querying AppSync for user with ID:', id);
    const response = await authenticatedClient.query<{ T26GetUser: User }>({
      query: gql`
        query T26GetUser($input: T26GetUserInput) {
          T26GetUser(input: $input) {
            id
            name
            email
            avatar
            points
          }
        }
      `,
      variables: { input: { id } },
      fetchPolicy: 'network-only',
    });
    return response.data.T26GetUser;
  } catch (error) {
    console.error('Failed to get user data:', error);
    throw error;
  }
};
